var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2Cm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 220,
    height: 220,
    viewBox: "0 0 220 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 210.505C165.228 210.505 210 165.734 210 110.505C210 55.2769 165.228 10.5054 110 10.5054C54.7715 10.5054 10 55.2769 10 110.505C10 165.734 54.7715 210.505 110 210.505ZM110 130.505C121.046 130.505 130 121.551 130 110.505C130 99.4597 121.046 90.5054 110 90.5054C98.9543 90.5054 90 99.4597 90 110.505C90 121.551 98.9543 130.505 110 130.505Z",
    fill: "#CC9B92",
    fillOpacity: 0.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 110,
    cy: 110.505,
    r: 20,
    stroke: "#37A851",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2Cm);
export default __webpack_public_path__ + "static/media/2cm.8753c16fbcc642921271150818d16a76.svg";
export { ForwardRef as ReactComponent };